<template>
  <div>   
    <v-card
      flat
      class="mt-3 pa-2 mx-1"
    >  
      <v-row 
        class="mx-2 my-2"
      >
        <h4>{{ $t('select-first-digit') }}</h4>
      </v-row>
      <v-row 
        no-gutters 
        class="px-2"
      > 
        <v-btn-toggle
          v-model="toggleSelected"
          color="#ff8282"
          class="d-block "
          style="width : 100% !important"
          mandatory
          borderless 
        >
          <v-btn 
            v-for="(item,i) in 10"
            :key="i"   
            width="17%" 
            class="notranslate force-round  ma-1" 
          >
            {{ i+'000' }}
          </v-btn>
        </v-btn-toggle> 
      </v-row>
      <v-row 
        no-gutters 
        class="mx-2 my-2"
      >
        <h4>{{ $t('select-second-digit') }}</h4>
      </v-row>
      <v-row 
        no-gutters 
        class="px-2"
      > 
        <v-btn-toggle
          v-model="toggleSelected2"
          class="d-block "
          style="width : 100% !important"
          color="#ff8282"
          mandatory
          borderless 
        >
          <v-btn 
            v-for="(item,i) in 10"
            :key="i" 
            width="17%" 
            class="notranslate force-round  ma-1" 
          >
            {{ '0'+i+'00' }}
          </v-btn>
        </v-btn-toggle> 
      </v-row>
    </v-card>
    <v-row 
      no-gutters  
    >
      <v-col
        class="px-1 mt-3"
        cols="12"
        md="7"
      >
        <v-row no-gutters> 
          <v-card
            flat
            width="100%"
            class="pa-3 "
          >
            <v-row
              no-gutters
              class="mx-1"
            > 
              <v-col 
                v-for="(item,i) in selectAmountList"
                :key="i"  
                class="column-five"
              > 
                <v-btn-toggle
                  v-model="selectAmount" 
                  color="#1365ff" 
                  class="d-block ma-1"
                  multiple 
                  borderless
                > 
                  <v-btn  
                    class="notranslate force-round"
                    block 
                    :value="item.value"
                    :color="checkLimitCondition(item)" 
                    :disabled="checkDisable(item)"
                    @click="addValue(item)" 
                  >
                    <h3>{{ checkDisable(item) ? $t('button.out-of-stock') : item.number }}</h3> 
                  </v-btn> 
                </v-btn-toggle> 
              </v-col>
            </v-row>
          </v-card>
        </v-row>
        <v-row no-gutters>
          <limitlistcard 
            :first-tab="firstTab" 
            :first-tab-status="firstTab.status"  
          /> 
        </v-row>
      </v-col>
      <v-col
        class="px-1  mt-3"
        cols="12"
        md="5"
      >
        <v-card
          flat
          class="text-center py-3"
        >
          <h4>{{ $t('enter-number') }}</h4>
          <v-row
            no-gutters
            class="mx-3"
          >
            <v-col class="px-1">
              <n-number-field-specific
                v-model="digitNumber1" 
                readonly 
              />
            </v-col>
            <v-col class="px-1">
              <n-number-field-specific
                v-model="digitNumber2"
                readonly 
              />
            </v-col>
            <v-col class="px-1">
              <n-number-field-specific
                v-model="digitNumber3"
                readonly 
              />
            </v-col>
            <v-col class="px-1">
              <n-number-field-specific
                v-model="digitNumber4"
                readonly 
              />
            </v-col>
          </v-row>
          <numPad
            :method-digit="addDigit"
            @removeLastNumber="removeLastNumber"
            @clearAll="clearAll"
            @removeDigit="removeDigit"
          />
        </v-card> 
        <slot />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import numPad from './NumPad'
import limitlistcard from './LimitList'
import * as c from '@/const/setTimeOutConfig'
import { findPermutations } from '@/plugins/helper'
export default {
  components:{
    numPad, 
    limitlistcard
  },
  props : {
    switchToggle : {
      type:Boolean,
      default:false
    },

    indexSelect : { 
      type:Number,
      default:0
    },

    firstTab : {
      type:[Object,Boolean],
      default:()=>{
        return {
          limit_conditions : []
          }
      }
    }, 
    userSelect:{
      type:Array,
      default:()=>{
        return[]
      }
    },
    filterNumber:{
      type:String,
      default:()=>''
    },    
    voucher:{
      type:Object,
      default:()=>{}
    },
  },  
  data (){
    return {  
      selectAmount:[],
      toggleSelected:0,
      toggleSelected2:0,
      selectAmountBase:[],
      LIMITL : 2, 
      ALMOST : 1, 
      NORMAL : 0,
      digitNumber1:'',
      digitNumber2:'',
      digitNumber3:'',
      digitNumber4:'', 
    }
  },  
  computed : {
    selectAmountList () { 
      let array = this.filterNumber ?
                  this.selectAmountBase
                  .filter(x=>x.number
                  .includes(parseInt(this.filterNumber))) :
                  this.selectAmountBase.slice(this.toggleSelected*1000+this.toggleSelected2*100,this.toggleSelected*1000+this.toggleSelected2*100+100)  
      return  array
    }
  },
  watch:{    
    indexSelect () { 
      this.initLimitCondition()
      this.checkStatusActive()
    },
    toggleSelected () { 
      this.checkStatusActive()
    },
     
    toggleSelected2 () { 
      this.checkStatusActive()
    },

    userSelect () {
      this.checkStatusActive()
    },
    digitNumber4 (){
      let value = this.digitNumber1.toString()+this.digitNumber2.toString()+this.digitNumber3.toString()+this.digitNumber4.toString()
      let item = this.selectAmountBase.find(x=>x.number===value)
      if(item && !this.selectAmount.includes(item.value)&&this.digitNumber4.length!==0){
        setTimeout(()=>{
        this.addValue(item)
        this.selectAmount.push(item.value)
        this.digitNumber1=''
        this.digitNumber2=''
        this.digitNumber3=''
        this.digitNumber4=''
        },c.COUNTDOWNONESEC)
      }
      else if(item && this.digitNumber4.length!==0 ){
          this.$noty.error(this.$t('already-select-number',{number:item.value}))    
          this.digitNumber1=''
          this.digitNumber2=''
          this.digitNumber3=''
          this.digitNumber4=''
      }
    },
  }, 
  async created () {
    this.$emit('changeStatus',this.firstTab.number_type.id,true)
    this.checkStatusActive()
    this.initLimitCondition() 
  }, 
  methods :{ 

    initLimitCondition () {    
      this.selectAmountBase = Array.from(Array(10000).keys()).map(x=>{
        let result = {
          value : x,
          number : this.changeNumbertoString(x),
          first : this.NORMAL,
          second : this.NORMAL,
          userReward_first : 0
        }  
        let firstLimitFind = (this.firstTab.limit_conditions || []).filter(x=>x.number===result.number)  
 
        if(firstLimitFind.length !==0){   
          let reward = Math.min.apply(Math,firstLimitFind.map(x=>x.quota_reward))  
          result.first = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward_first =  reward
        }  
        return result
      })   
    },  
    
    checkDisable (item) {
      let check =  this.firstTab.status ? item.first : null 
      return check === this.LIMITL ? true : false
    },

    checkLimitCondition (item) { 
      let check =  item.first 
      switch(check){
        case this.NORMAL:
          return ''
        case this.ALMOST:
          return 'red'
        case this.LIMITL:
          return 'red'
          
      }
      return '' 
    }, 

    checkStatusActive () {  
      this.resetBoardDisplay()  
      this.userSelect.forEach(element => {
        if((element.number_type_id===this.firstTab.number_type.id)) {
          this.selectAmount.push(parseInt(element.number)) 
        }
      });  
    }, 

    clearAll (){  
      this.$emit('clearAll') 
    },

    resetBoardDisplay () { 
      this.selectAmount = []  
    },

    removeDigit (){
      if(this.digitNumber2.length===0){
        this.digitNumber1 = ''
      }else if(this.digitNumber3.length===0){
        this.digitNumber2=''
      }else {
        this.digitNumber3=''
      }
    },

    addDigit (number){
      if(this.digitNumber1.length===0){
          this.digitNumber1 = number
      }
      else if(this.digitNumber2.length===0){
          this.digitNumber2 = number
      }
      else if(this.digitNumber3.length===0){
          this.digitNumber3 = number
      }
      else{
          this.digitNumber4 = number
      }
    }, 

    removeLastNumber (){  
      this.$emit('removeLastNumber')
    }, 

    changeNumbertoString (value){  
      return  value<10 ? "000"+value.toString() : value<100 ? "00"+ value.toString() : value<1000 ?  "0"+ value.toString()  : value.toString()  
    },

    switchNumbertoString (value) {
      return findPermutations(this.changeNumbertoString(value))
      .filter(x=>!this.selectAmount.includes(parseInt(x)))
      .map(x=>this.selectAmountBase.find(y=>y.number===x)) 
    },

    addValue (item) {
      let changeNumbertoString = item.number
      this.$ga.event('Button', 'Add&DeleteValue', 'FourDigitPage', changeNumbertoString)
      let arrayResult = this.switchToggle && !this.selectAmount.includes(item.value) 
      ? this.switchNumbertoString (item.value)
      : [changeNumbertoString].map(x=>this.selectAmountBase.find(y=>y.number===x))  
      let Bypass = false 
      let stakeMaxNumber = (this.voucher.rules || {}).stake_max_number
      let checkVoucherStake = this.voucher.rules && stakeMaxNumber

      arrayResult.forEach(e=>{
        let status = this.selectAmount.includes(e.value)
        let actionStatus = status ? 'delValue': 'addValue' 
  
        if( checkVoucherStake &&
            this.userSelect.length >= parseInt(stakeMaxNumber) &&
            actionStatus === 'addValue'
          ){ 
          if(!Bypass) {  
            this.$nextTick(()=>{
              this.checkStatusActive() 
            }) 
          }
          
          Bypass = true
          return
        } 

        if(e.first !== this.LIMITL){ 
          let price = e.first === this.NORMAL ? this.firstTab.userReward : e.userReward_first
          this.$emit(actionStatus,price,e.number,this.firstTab.number_type.id,null,null,null)
        }  
      }) 
    },   
  }
}
</script> 
<style scoped>
@media only screen and (min-width: 1264px) {
  .column-five {
    flex: 0 0 10% !important;
    max-width: 10% !important;
  }
}  
</style>